import React, { useRef } from 'react';
import styles from './HoverExpandText.module.scss';
import cx from 'classnames';

const INIT_SPAN_HEIGHT = 16;

const HoverExpandText = ({ status, description, className }) => {
    const spanRef = useRef(null);

    const handleMouseEnter = () => {
        spanRef.current.style.height = `${spanRef.current.scrollHeight}px`;
    };

    const handleMouseLeave = () => {
        spanRef.current.style.height = `${INIT_SPAN_HEIGHT}px`;
    };

    return <div className={cx(styles.container, className)}>
        <div className={styles.title}>{status}</div>
        <div className={styles.descriptionContainer} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <span ref={spanRef} style={{ '--init-height': `${INIT_SPAN_HEIGHT}px` }} className={styles.text}>{description}</span>
        </div>
    </div>
};

export default HoverExpandText;